import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { yfList, delyf } from "@/api/financial/consumptionDetails";
import addYfparams from "./components/addYfparams";
export default {
  name: "yfparams",
  components: {
    addYfparams: addYfparams
  },
  mixins: [tabulation],
  data: function data() {
    return {
      searchData: {
        page_size: 10,
        page: 1
      },
      tableData: [],
      value2: [],
      total: 0,
      sels: [],
      selsString: '',
      InitializeOrNot: false,
      adPlacementSingleChoice: true
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == 'valuets' ? [''] : searchData.ad_placement;
      this.reqLoading = true;
      yfList(searchData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.data.length && e > 1) {
            _this.searchClick(e - 1);
          } else {
            var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
            _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : []; // .length ? this.$utils.dataConversion(res.data.data, list) : [];

            _this.total = res.data.total;

            _this.$nextTick(function () {
              _this.getTableRight();
            });
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSource: function handleSource(id) {
      this.$refs.addYfparams.init(id);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels;
    },
    handleDelete: function handleDelete(ids) {
      var _this3 = this;

      var id = ids.toString();
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delyf({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this3.searchClick(_this3.searchData.page);

                    _this3.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};